module.exports = "<sx-template-listado \r\n  [titulo]=\"'Outputs'\"\r\n  [listado]=\"outputs\"> \r\n</sx-template-listado>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/list.output.component.html
// module id = ../../../../../src/app/private/outputs/list.output.component.html
// module chunks = main